
import Vue from "vue";
import { mapFields } from "vuex-map-fields";
import SammanstallningField from "@/components/Kontaktuppgifter/SammanstallningField.vue";

export default Vue.extend({
    name: "FelaktigRedovisningSammanstallning",
    components: {
        SammanstallningField,
    },
    computed: {
        ...mapFields([
            "observationer.assistansErsattning.assistansTidInteArbetar",
            "observationer.assistansErsattning.assistansTidAnnanSysselsattning",
            "observationer.assistansErsattning.ekonomiskaOegentligheter",
        ]),
    },
});
